/**
 * fps 告警监听器
 * [阈值, 监听器]
 */
const alertMonitors = [];
const avgCheckers = new Set();
let frame = 0;
let lastTime = 0;
let fpsList = [];
let running = false;
let rafId = 0;
const loop = function () {
    frame++;
    const now = performance.now();
    const gap = now - lastTime;
    if (gap >= 1000) {
        const fps = Math.round((frame * 1000) / gap);
        lastTime = now;
        frame = 0;
        fpsList.push(fps);
        // 保留最近 10 个记录
        fpsList = fpsList.slice(-10);
        if (fpsList.length === 10) {
            const maxFPS = Math.max(...fpsList);
            for (const [lowerLimit, fns] of alertMonitors) {
                // 连续 10s 低于预期值，执行回调
                if (maxFPS < lowerLimit) {
                    fns.forEach(fn => fn());
                }
            }
        }
        const avg = fpsList.reduce((a, b) => a + b, 0) / fpsList.length;
        avgCheckers.forEach(fn => fn(avg));
    }
    if (running)
        rafId = requestAnimationFrame(loop);
};
function restart() {
    lastTime = performance.now();
    fpsList = [];
    frame = 0;
    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(loop);
}
document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
        restart();
    }
    // hidden 时， raf 会自动停止执行
});
/**
 * 监听fps，连续 10s 低于指定值会触发回调
 * @param fn
 * @return 取消监听函数
 */
export function monitorFPS(opts, fn) {
    if (opts.type === 'alert') {
        let entity = alertMonitors.find(([v]) => opts.threshold === v);
        if (entity == null) {
            entity = [opts.threshold, new Set()];
            alertMonitors.push(entity);
            alertMonitors.sort(([v1], [v2]) => v1 - v2);
        }
        entity[1].add(fn);
    }
    else if (opts.type === 'avg') {
        avgCheckers.add(fn);
    }
    if (!running) {
        running = true;
        restart();
    }
    // 移除监听逻辑
    return () => {
        var _a;
        if (opts.type === 'alert') {
            (_a = alertMonitors.find(([thrshold]) => thrshold === opts.threshold)) === null || _a === void 0 ? void 0 : _a[1].delete(fn);
        }
        else if (opts.type === 'avg') {
            avgCheckers.delete(fn);
        }
        if (alertMonitors.map(([, s]) => s)
            .every(s => s.size === 0) &&
            avgCheckers.size === 0) {
            running = false;
            cancelAnimationFrame(rafId);
        }
    };
}
//# sourceMappingURL=fps-monitor.js.map